<template>
  <div class="footer-content">
    <div class="nav">
      <a href="./index_m.html">{{$t('首页')}}</a>
      <a href="./recharge_m.html">{{$t('充值中心')}}</a>
      <a href="./account_m.html">{{$t('个人中心')}}</a>
      <a href="./help_m.html">{{$t('客服中心')}}</a>
    </div>
    <div class="footer-content">
      <a href="./privacy_m.html">
        {{$t('隐私协议')}}
      </a>
      <span>丨</span>
      <a href="./user_m.html">{{$t('用户协议')}}</a>
      <p>{{$t('©2019 Trigirls Studio 工作室版权所有，页面内所有提及商标及素材均为其所有。')}}</p>
    </div>
    <a href="./index_m.html"
       class="logo">
      <img src="../images/logo.png"
           alt="">
    </a>
  </div>
</template>
<script>
export default {
  name: 'footer_m',
  data() {
    return {};
  },
  methods: {
  }
};
</script>
<style lang="less">
@mainColor: #fc2900;
.footer-content {
  background-color: #f1f1f1;
  font-size: 0.2rem;
  color: @mainColor;
  padding: 0.26rem 0.2rem 0.2rem 0.2rem;
  a {
    text-decoration: none;
    color: @mainColor;
  }
  .nav {
    display: flex;
    width: 100%;
    justify-content: center;
    a {
      width: 1.06rem;
      height: 0.34rem;
      line-height: 0.34rem;
      text-align: center;
      border: 1px solid @mainColor;
      margin: 0 0.24rem;
      border-radius: 0.05rem;
    }
  }
  .footer-content {
    text-align: center;
    font-size: 0.2rem;
    padding: 0.36rem 0 0.28rem;
    border-bottom: 1px solid @mainColor;

    p {
      margin-top: 0.2rem;
      font-size: 0.16rem;
      color: #717171;
    }
  }
  .logo {
    margin: 0.15rem auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 0.6rem;
      width: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/footer_m.vue